import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { NeuroscienceSection } from './NeuroscienceSection';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-225" data-mp="185q2rtyd49uw">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-226" data-mp="1c6a1v32hxnjo">
        <div className="text-center" data-id="element-227" data-mp="1zsyn9yqpry51">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-228" data-mp="24unzvitl4jv8">
            🧩 THE AUTONOMOUS CHILD VISUAL SYSTEM™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-229" data-mp="1qu3goljrcm17">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-230" data-mp="ffhjtzw05lf9">
            6 routine volumes · 50 print-ready pages — morning, afternoon and night in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-231" data-mp="kflyrlh9i83d">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-232" data-mp="3o8op9rllf4ph">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-233" data-mp="1yvlka9l300g">
            📚 The 6 Routine Volumes
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="b0bx4lc4x869">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-235" data-mp="61sa0hlt1qcb" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-236" data-mp="11skhyv309210">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-237" data-mp="11t3pdhv1480s">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-238" data-mp="1bkgei1pg0k34">
                  <span aria-hidden="true" data-id="element-239" data-mp="1fjz3b8kdxfb8">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-240" data-mp="1pieu1afi2mk7">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-241" data-mp="1ui145b017mos">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-242" data-mp="3ra1cgnlbt952">
            ✅ Key features — simple to use, flexible to adapt
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-243" data-mp="406gtg7x5qa">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-244" data-mp="2df1c0lzasa4g">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-245" data-mp="28lgnrlniauig" />
                {item}
              </li>)}
          </ul>
        </div>

        <NeuroscienceSection data-id="element-246" data-mp="1zmv8bzdbzvlw" />

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "5px",
        paddingBottom: "6px"
      }} data-id="element-247" data-mp="1znmrgapqs0va">
          <p className="font-display text-lg font-black text-blush-deep" data-id="element-248" data-mp="2sahd3ayap6ac">
            No other subscription
          </p>
          <p className="mt-2 text-sm text-plum/70" style={{
          fontWeight: "600"
        }} data-id="element-249" data-mp="2nav092mdps22">
            <span className="block" data-id="element-250" data-mp="2idmeks20v5w2">❌ Therapy Session: $150/hour</span>
            <span className="block" data-id="element-251" data-mp="1bwr71ynm87y2">❌ Subscription Apps: $120/year</span>
            <span className="block font-bold text-plum" style={{
            textDecorationLine: "none"
          }} data-id="element-252" data-mp="1by26jma12tjd">✅ Sigma Smart System (150+ Icons + Neuroscience Protocol):  <span className="text-blush" data-id="element-253" data-mp="2utu7n1zuqcyq">$19</span></span>
            <span className="block font-bold text-plum" data-id="element-254" data-mp="2us9cba5pqpzt">✅ One-time payment forever</span> 
          </p>
          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-plum/80" data-id="element-255" data-mp="2zn6vvb0mchqy">
            {['No monthly subscription', 'No ads', 'No files to install', 'Mobile-friendly'].map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-256" data-mp="2qqebs7vlwgn3">
                <CheckIcon className="h-4 w-4 shrink-0 text-blush" strokeWidth={3} data-id="element-257" data-mp="3ej4m6cnv2rv9" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}